module.exports = __webpack_public_path__ + "media/images/front/icon_db_200_kyousei-aa59ef3c8a3c60564edfa5d44ecb5433.png";